import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useUser } from '~/composables/_next/useUser';
import { useLocalization } from '~/composables/_next/useLocalization';
var productWishlist = ref();

/**
 * Hook for managing product wishlists.
 */
export var useProductWishlistStore = function useProductWishlistStore() {
  var versionOfWishlist = computed(function () {
    return productWishlist.value.version;
  });
  var _useLocalization = useLocalization(),
    country = _useLocalization.country,
    currency = _useLocalization.currency;
  var idOfWishlist = computed(function () {
    return productWishlist.value.id;
  });
  var _useUser = useUser(),
    isAuthenticated = _useUser.isAuthenticated;
  var _useNuxt2App = useNuxt2App(),
    api = _useNuxt2App.$vsf.$ct.api,
    $sentry = _useNuxt2App.$sentry;
  /**
   * Fetches the product wishlist from the API and handles duplicates.
   * @param {boolean} [force=false] - Force reload even if the wishlists are already loaded.
   * @returns {Promise<void>} - The result of the fetch operation.
   */
  function fetchProductWishlist() {
    return _fetchProductWishlist.apply(this, arguments);
  }
  /**
   * Adds a product to a wishlist.
   * @param {string} productId - The ID of the product to add.
   */
  function _fetchProductWishlist() {
    _fetchProductWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _initialResponse$data, _initialResponse$data2, _initialResponse$data3;
      var force,
        initialResponse,
        initialWishlist,
        hasDuplicates,
        updatedResponse,
        _updatedResponse$data,
        updatedWishlist,
        _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            force = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            if (!((productWishlist.value || !isAuthenticated.value) && !force)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _context.next = 5;
            return api.getShoppingLists({
              getMe: 'wishlistCustom'
            });
          case 5:
            initialResponse = _context.sent;
            if (!((_initialResponse$data = initialResponse.data) !== null && _initialResponse$data !== void 0 && (_initialResponse$data2 = _initialResponse$data.me) !== null && _initialResponse$data2 !== void 0 && (_initialResponse$data3 = _initialResponse$data2.shoppingLists) !== null && _initialResponse$data3 !== void 0 && _initialResponse$data3.results)) {
              $sentry.setContext('wishlist', initialResponse);
              $sentry.captureException(new Error('Unexpected response structure for Product Wishlist'));
            }
            initialWishlist = initialResponse.data.me.shoppingLists.results[0];
            productWishlist.value = initialWishlist;
            _context.next = 11;
            return handleDuplicateProducts(initialWishlist);
          case 11:
            hasDuplicates = _context.sent;
            if (!hasDuplicates) {
              _context.next = 19;
              break;
            }
            _context.next = 15;
            return api.getShoppingLists({
              getMe: 'wishlistCustom'
            });
          case 15:
            updatedResponse = _context.sent;
            if (updatedResponse.data) {
              updatedWishlist = (_updatedResponse$data = updatedResponse.data.me.shoppingLists) === null || _updatedResponse$data === void 0 ? void 0 : _updatedResponse$data.results[0];
              productWishlist.value = updatedWishlist !== null && updatedWishlist !== void 0 ? updatedWishlist : null;
            }
            _context.next = 20;
            break;
          case 19:
            productWishlist.value = initialWishlist !== null && initialWishlist !== void 0 ? initialWishlist : null;
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchProductWishlist.apply(this, arguments);
  }
  function addProductToWishlist(_x) {
    return _addProductToWishlist.apply(this, arguments);
  }
  /**
   * Removes a product from a wishlist.
   * @param {string} lineItemId - The ID of the line item to remove.
   */
  function _addProductToWishlist() {
    _addProductToWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(productId) {
      var _result$data;
      var action, result;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            action = {
              addLineItem: {
                quantity: 1,
                productId: productId
              }
            };
            _context2.next = 3;
            return api.updateProductWishlistAction({
              id: idOfWishlist.value,
              version: versionOfWishlist.value,
              actions: [action],
              currency: currency,
              country: country
            });
          case 3:
            result = _context2.sent;
            productWishlist.value = result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.wishlist;
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _addProductToWishlist.apply(this, arguments);
  }
  function removeProductFromWishlist(_x2) {
    return _removeProductFromWishlist.apply(this, arguments);
  }
  /**
   * Removes duplicate products from the shopping list's line items.
   *
   * @param {ShoppingList} initialWishlist - The shopping list containing line items.
   * @returns {Promise<boolean>} - Resolves to true if duplicates were removed, false otherwise.
   */
  function _removeProductFromWishlist() {
    _removeProductFromWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(lineItemId) {
      var _result$data2;
      var action, result;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            action = {
              removeLineItem: {
                lineItemId: lineItemId
              }
            };
            _context3.next = 3;
            return api.updateProductWishlistAction({
              id: idOfWishlist.value,
              version: versionOfWishlist.value,
              actions: [action],
              currency: currency,
              country: country
            });
          case 3:
            result = _context3.sent;
            productWishlist.value = result === null || result === void 0 ? void 0 : (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.wishlist;
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _removeProductFromWishlist.apply(this, arguments);
  }
  function handleDuplicateProducts(_x3) {
    return _handleDuplicateProducts.apply(this, arguments);
  }
  /**
   * Check if the product is in the wishlist.
   * We have to fake the variant sku as VSF is expecting it
   * and we are not sending it most of the time.
   *
   * @param {Object} item - The product
   * @returns {boolean} Whether the product is in the wishlist
   */
  function _handleDuplicateProducts() {
    _handleDuplicateProducts = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(initialWishlist) {
      var _initialWishlist$line;
      var productIdCount, itemsToRemove, _iterator, _step, item;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            productIdCount = {};
            itemsToRemove = [];
            initialWishlist === null || initialWishlist === void 0 ? void 0 : (_initialWishlist$line = initialWishlist.lineItems) === null || _initialWishlist$line === void 0 ? void 0 : _initialWishlist$line.forEach(function (item) {
              var _item$productId;
              var productId = (_item$productId = item.productId) !== null && _item$productId !== void 0 ? _item$productId : '';
              if (productId in productIdCount) {
                productIdCount[productId]++;
                itemsToRemove.push(item);
              } else {
                productIdCount[productId] = 1;
              }
            });
            if (!(itemsToRemove.length > 0)) {
              _context4.next = 22;
              break;
            }
            _iterator = _createForOfIteratorHelper(itemsToRemove);
            _context4.prev = 5;
            _iterator.s();
          case 7:
            if ((_step = _iterator.n()).done) {
              _context4.next = 13;
              break;
            }
            item = _step.value;
            _context4.next = 11;
            return removeProductFromWishlist(item.id);
          case 11:
            _context4.next = 7;
            break;
          case 13:
            _context4.next = 18;
            break;
          case 15:
            _context4.prev = 15;
            _context4.t0 = _context4["catch"](5);
            _iterator.e(_context4.t0);
          case 18:
            _context4.prev = 18;
            _iterator.f();
            return _context4.finish(18);
          case 21:
            return _context4.abrupt("return", true);
          case 22:
            return _context4.abrupt("return", false);
          case 23:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[5, 15, 18, 21]]);
    }));
    return _handleDuplicateProducts.apply(this, arguments);
  }
  function checkProductInWishlist(item) {
    var _productWishlist$valu;
    if (!item || !productWishlist.value) {
      return false;
    }
    var wishlist = (_productWishlist$valu = productWishlist.value) !== null && _productWishlist$valu !== void 0 ? _productWishlist$valu : {};
    if (!wishlist.lineItems) return false;
    var index = wishlist.lineItems.findIndex(function (lineItem) {
      return lineItem.productId === item;
    });
    return index !== -1;
  }
  return {
    productWishlist: productWishlist,
    fetchProductWishlist: fetchProductWishlist,
    checkProductInWishlist: checkProductInWishlist,
    removeProductFromWishlist: removeProductFromWishlist,
    addProductToWishlist: addProductToWishlist
  };
};